const scaleBetween = (upper: number, lower: number, coeff: number) =>
  upper - (upper - lower) * (coeff > 1 ? 1 : coeff);

export { scaleBetween };
